import { GROUP_KEY } from 'api/Group/constants'
import type { RequestStoresType } from 'api/Stores/types'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyArray } from 'utils'

import type { GetDateKeyOptions, RequestParams } from './types'

interface RequestAction extends Action {
  payload: {
    channel?: string
    countryId?: string
    dateCurrent: RequestDate
    owner?: string
    saleType?: string
    storesType?: RequestStoresType
    [prop: string]: RequestDate | string | number | null | undefined
  }
}

export function getRequestParams({ payload }: RequestAction, ignoreFields: string[] = emptyArray) {
  let params: RequestParams = {}

  if (!ignoreFields.includes('channel') && payload.channel) params.channel = payload.channel
  if (!ignoreFields.includes('countryId') && payload.countryId) params.countryId = payload.countryId
  if (!ignoreFields.includes('owner') && payload.owner) params.owner = payload.owner
  if (!ignoreFields.includes('saleType') && payload.saleType) params.saleType = payload.saleType
  if (!ignoreFields.includes('storesType') && payload.storesType === 'stores') params.necoms = true
  if (!ignoreFields.includes('storesType') && payload.storesType === 'websites') params.ecoms = true

  return params
}

const INVALID_DATA_KEY = 'invalid-data-key'

function getLevelKey({
  channel,
  channelsType,
  countryId,
  isListDetailsOpen,
  owner,
  saleType,
  storesType,
  subListTypeSelected,
  type,
}: GetDateKeyOptions) {
  if (type === 'group') return []

  if (storesType === 'stores' || storesType === 'websites') {
    return [!isListDetailsOpen && subListTypeSelected, channel, countryId, owner, saleType]
  }

  if (channelsType === 'channels') return [channel]
  if (channelsType === 'saleTypes') return [saleType]
  if (channelsType === 'countries') return [countryId]
  if (channelsType === 'owners') return [owner]

  return []
}

export function getDateKey(options: GetDateKeyOptions, isGroup = false) {
  const { channelsType, dateCurrent, dateCompared, range, type } = options
  const requestDateCurrent = (dateCurrent || '').slice(0, 10)
  const requestDateCompared = (dateCompared || '').slice(0, 10)

  return (
    [
      isGroup || type === 'group' ? GROUP_KEY : channelsType,
      ...getLevelKey(options),
      requestDateCurrent,
      requestDateCompared,
      range,
    ]
      .filter(Boolean)
      .join('.') || INVALID_DATA_KEY
  )
}
